// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-clearable {\n  margin-right: 2rem;\n}\n\n.date-clearable:after {\n  background: rgb(76, 140, 238);\n  color: white;\n  font-weight: 900;\n  font-size: 11px;\n}", ""]);
// Exports
module.exports = exports;
